import {
  ITEM_DIETARY_FIELDS,
  ITEM_ALLERGEN_FIELDS,
  ITEM_AVAILABILITY_DEFAULTS,
} from "./menuItemConstants"

/** Traductions de nom, prix et description par plat (Encas, petit déj, etc.) */
export const emptyItemTranslations = () => ({
  fr: { name: "", price: "", description: "" },
  en: { name: "", price: "", description: "" },
  ar: { name: "", price: "", description: "" },
})

const buildBooleanFieldDefaults = (fields, value = false) =>
  fields.reduce((acc, field) => {
    acc[field] = value
    return acc
  }, {})

export const createDefaultMenuItem = () => ({
  name: "",
  description: "",
  price: "",
  translations: emptyItemTranslations(),
  reservable: true,
  ...buildBooleanFieldDefaults(ITEM_DIETARY_FIELDS),
  ...buildBooleanFieldDefaults(ITEM_ALLERGEN_FIELDS),
  ...ITEM_AVAILABILITY_DEFAULTS,
})

const applyMenuItemFieldDefaults = (item) => {
  const next = { ...item }
  ITEM_DIETARY_FIELDS.forEach((field) => {
    if (next[field] == null) next[field] = false
  })
  ITEM_ALLERGEN_FIELDS.forEach((field) => {
    if (next[field] == null) next[field] = false
  })
  Object.entries(ITEM_AVAILABILITY_DEFAULTS).forEach(([field, value]) => {
    if (next[field] == null) next[field] = value
  })
  return next
}

/**
 * À l’édition : assure translations.fr/en/ar.name + price + description + garde racine (souvent = FR).
 */
export const normalizeMenuItemFromApi = (item) => {
  if (!item || typeof item !== "object") return createDefaultMenuItem()
  const tr = item.translations || {}
  
  const frPrice = tr.fr?.price != null && String(tr.fr.price).trim() !== "" ? String(tr.fr.price) : String(item.price ?? "")
  const frName = tr.fr?.name != null && String(tr.fr.name).trim() !== "" ? String(tr.fr.name) : String(item.name ?? "")
  const frDesc = tr.fr?.description != null && String(tr.fr.description).trim() !== "" ? String(tr.fr.description) : String(item.description ?? "")
  
  return applyMenuItemFieldDefaults({
    ...item,
    price: item.price != null && item.price !== "" ? String(item.price) : frPrice,
    name: item.name != null && item.name !== "" ? String(item.name) : frName,
    description: item.description != null && item.description !== "" ? String(item.description) : frDesc,
    translations: {
      fr: { name: frName, price: frPrice, description: frDesc },
      en: { 
        name: tr.en?.name != null ? String(tr.en.name) : "", 
        price: tr.en?.price != null ? String(tr.en.price) : "",
        description: tr.en?.description != null ? String(tr.en.description) : ""
      },
      ar: { 
        name: tr.ar?.name != null ? String(tr.ar.name) : "", 
        price: tr.ar?.price != null ? String(tr.ar.price) : "",
        description: tr.ar?.description != null ? String(tr.ar.description) : ""
      },
    },
  })
}

/** Avant envoi API : racine = FR, objet translations complet */
export const prepareMenuItemsForSubmit = (items) =>
  (items || []).map((it) => {
    const tr = it.translations || emptyItemTranslations()
    const frPrice = tr.fr?.price ?? it.price ?? ""
    const frName = tr.fr?.name ?? it.name ?? ""
    const frDesc = tr.fr?.description ?? it.description ?? ""
    return {
      ...it,
      price: frPrice,
      name: frName,
      description: frDesc,
      translations: {
        fr: { ...tr.fr, name: frName, price: frPrice, description: frDesc },
        en: { 
          ...tr.en, 
          name: tr.en?.name ?? "", 
          price: tr.en?.price ?? "",
          description: tr.en?.description ?? "" 
        },
        ar: { 
          ...tr.ar, 
          name: tr.ar?.name ?? "", 
          price: tr.ar?.price ?? "",
          description: tr.ar?.description ?? ""
        },
      },
    }
  })
